import { render, staticRenderFns } from "./ChartsList.vue?vue&type=template&id=f8b86a62&"
import script from "./ChartsList.vue?vue&type=script&lang=js&"
export * from "./ChartsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports